module.exports = __webpack_public_path__ + "img/gi_peranggalaksi.1da0c350.png";